import { TitleCasePipe } from '@angular/common';
import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Table } from 'primeng/table';
import * as moment from 'moment';
import { ConfirmationService, LazyLoadEvent, MessageService } from 'primeng/api';
import { Dropdown } from 'primeng/dropdown';
import { environment } from 'src/environments/environment';
import { FeaturedThisWeekService } from 'src/app/services/featured-this-week.service';
import { saveAs } from 'file-saver/src/FileSaver';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-featured-this-week',
  templateUrl: './featured-this-week.component.html',
  styleUrls: ['./featured-this-week.component.scss'],
  providers: [ConfirmationService, TitleCasePipe, MessageService]
})

export class FeaturedThisWeekComponent implements OnInit, OnDestroy {

  private destroy$ = new Subject<void>();
  public hide: boolean = true;
  searchBy: any[] = [];
  searchby: any;
  startDate: Date;
  endDate: Date;
  @ViewChild("dt", { static: false }) public dt: Table;
  @ViewChild("pDropDownId", { static: false }) pDropDownId: Dropdown;
  public lastTableLazyLoadEvent: LazyLoadEvent;
  featuredThisWeekData: any;
  totalFeaturedThisWeekDataCount: number = 0;
  paginationOption: any;
  calvalue: Date;
  ucalvalue: Date;
  statuses: any[];
  errorMessage: any;
  showThumbNailImage: boolean = false;
  loading: boolean;
  responsiveOptions: any[] = [
    {
      breakpoint: '1024px',
      numVisible: 5
    },
    {
      breakpoint: '768px',
      numVisible: 3
    },
    {
      breakpoint: '560px',
      numVisible: 1
    }
  ];
  thumbnailImageArray: any[] = [];
  downloadFlg: boolean;
  downloadFeaturedThisWeekList: any;
  title: any;
  description: any;
  createdBy: any;
  updatedBy: any;

  constructor(private router: Router, private featuredThisWeekService: FeaturedThisWeekService, private messageService: MessageService, private confirmationService: ConfirmationService) { }

  ngOnInit(): void {
    this.paginationOption = environment.pagination;
    this.searchBy = [
      { label: 'Created On', value: "created_at" },
      { label: 'Last Modified On', value: "updated_at" }
    ];
    this.statuses = [
      { label: 'Active', value: true },
      { label: 'In-Active', value: false }
    ];
  }

  addNewFeaturedThisWeek() {
    this.router.navigate(['/manage/featured-this-week/add']);
  }

  loadFeaturedThisWeekList(event: LazyLoadEvent) {
    this.lastTableLazyLoadEvent = event;
    let query = "?filterByDisable=false";
    let pagenumber = 1;
    let params = "";
    let rows = 10;
    if (event !== undefined) {
      if (event.first != undefined && event.first == 0) {
        pagenumber = event.first + 1;
      } else if (event.first != undefined && event.first > 0) {
        pagenumber = (event.first / event.rows) + 1;
      } else {
        pagenumber = 1;
      }
      if (event.rows != undefined) {
        rows = event.rows;
      } else {
        rows = 10;
      }
    }
    if (this.searchby != undefined && this.startDate != undefined && this.endDate != undefined) {
      params += "&filterByDate=" + this.searchby.value;
      params += "&filterByStartDate=" + moment(this.startDate).format("YYYY-MM-DD");
      params += "&filterByEndDate=" + moment(this.endDate).format("YYYY-MM-DD");
    }
    if (event.filters != undefined && event.filters["title"] != undefined) {
      params += "&filterByTitle=" + event.filters["title"].value;
    }
    if (event.filters != undefined && event.filters["description"] != undefined) {
      params += "&filterByDescription=" + event.filters["description"].value;
    }
    if (event.filters != undefined && event.filters["status"] != undefined) {
      params += "&filterByStatus=" + event.filters["status"].value;
    }
    if (event.filters != undefined && event.filters["created_at"] != undefined) {
      const createdAt = moment(event.filters["created_at"].value).format("YYYY-MM-DD");
      params += "&filterByCreatedAt=" + createdAt;
    }
    if (event.filters != undefined && event.filters["createdBy"] != undefined) {
      params += "&filterByCreatedby=" + event.filters["createdBy"].value;
    }
    if (event.filters != undefined && event.filters["updated_at"] != undefined) {
      const updatedAt = moment(event.filters["updated_at"].value).format("YYYY-MM-DD");
      params += "&filterByUpdatedAt=" + updatedAt;
    }
    if (event.filters != undefined && event.filters["updatedBy"] != undefined) {
      params += "&filterByUpdatedby=" + event.filters["updatedBy"].value;
    }
    if (params != undefined && params != "") {
      query += "&pageSize=" + rows + "&pageNumber=" + pagenumber + params;
    } else {
      query += "&pageSize=" + rows + "&pageNumber=" + pagenumber;
    }
    if (event.sortField != undefined && event.sortOrder != undefined) {
      let orderBy = "";
      if (event.sortOrder == 1) {
        orderBy = "DESC";
      } else {
        orderBy = "ASC";
      }
      query += "&sortBy=" + event.sortField + "&orderBy=" + orderBy;
    }
    this.featuredThisWeekService.getFeaturedThisWeek(query).pipe(takeUntil(this.destroy$)).subscribe((data: any) => {
    
      if (this.downloadFlg === true) {
        
        this.exportExcelSheet(data.items.items);
      } else {
        this.featuredThisWeekData = data.items.items;
        this.totalFeaturedThisWeekDataCount = data.items.totalCount;
      }
    }, (error) => {
      this.messageService.add({ key: 'toastmsg', severity: 'error', summary: "Error", detail: error.error.message, life: 6000 });
    })
  }

  clear() {
    this.startDate = null;
    this.endDate = null;
    this.searchby = '';
    this.dt.filter('', 'title', 'contains');
    this.dt.filter('', 'description', 'contains');  
    this.dt.filter('', 'status', 'contains');
    this.dt.filter('', 'created_at', 'dateIs');
    this.dt.filter('', 'createdBy', 'contains');
    this.dt.filter('', 'updated_at', 'dateIs');
    this.dt.filter('', 'updatedBy', 'contains');
    this.title = '';
    this.description = '';
    this.createdBy = '';
    this.updatedBy = '';
    this.calvalue = null;
    this.ucalvalue = null;
    this.pDropDownId.clear(null);
    if (this.pDropDownId) {
      this.pDropDownId.value = null;
    }
  }

  exportExcel() {
    this.downloadFlg = true;
    this.loadFeaturedThisWeekList(this.lastTableLazyLoadEvent);
  }

  exportExcelSheet(featuredThisWeekList) {
      var propertiesRemove = ['_id','disable','created_by','updated_by'];
      this.downloadFeaturedThisWeekList = featuredThisWeekList;
      this.downloadFeaturedThisWeekList.forEach(function (item) {
        if (item.status) {
          item['status'] = 'Active';
        } else {
          item['status'] = 'In-Active';
        }
        propertiesRemove.forEach(function (prop) {
          delete item[prop];
        });
      });
      import("xlsx").then(xlsx => {
        const worksheet = xlsx.utils.json_to_sheet(this.downloadFeaturedThisWeekList);
        const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
        const excelBuffer: any = xlsx.write(workbook, {
          bookType: "xlsx",
          type: "array"
        });
        this.saveAsExcelFile(excelBuffer, "FeaturedThisWeekList");
        this.downloadFlg = false;
      });
    }

  saveAsExcelFile(buffer: any, fileName: string): void {
    import("file-saver").then(FileSaver => {
      let EXCEL_TYPE =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      let EXCEL_EXTENSION = ".xlsx";
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
      });
      let filename;
      filename = fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION;
      saveAs(data, filename);
    });
  }

changeStatus(featuredThisWeekData) {

  const newStatus = featuredThisWeekData.status;
  const oldStatus = !newStatus;

  this.confirmationService.confirm({
    message: `
      <h4 style="margin:0;">Are you sure?</h4>
      <p style="margin-top:10px;">
        You want to change this status?
      </p>
    `,
    header: 'Confirm',
    icon: 'pi pi-exclamation-triangle',
    acceptLabel: 'Confirm',
    rejectLabel: 'Cancel',
    acceptIcon: '',
    rejectIcon: '',

    accept: () => {

      const updatedata = {
        status: newStatus
      };

      this.featuredThisWeekService
        .updateFeaturedThisWeek(
          featuredThisWeekData._id,
          updatedata
        )
        .pipe(takeUntil(this.destroy$))
        .subscribe(
          data => {

            this.messageService.add({
              key: 'toastmsg',
              severity: 'success',
              summary: 'Successful',
              detail: 'featured-this-week Status Updated',
              life: 3000
            });

            setTimeout(() => {
              this.loadFeaturedThisWeekList(
                this.lastTableLazyLoadEvent
              );
            }, 1000);
          },
          err => {
            featuredThisWeekData.status = oldStatus;
            this.errorMessage = err.error.message;
          }
        );
    },

    reject: () => {
      featuredThisWeekData.status = oldStatus;
    }
  });
}
  onDelete(featuredThisWeekData) {
    this.confirmationService.confirm({
      // message: 'Are you sure you want to delete ' +(this.titlecasePipe.transform(featuredThisWeekData.title))+ '?',
      // header: 'Confirm',
      // icon: 'pi pi-exclamation-triangle',
           message: `
      <h4 style="margin:0;">Are you sure?</h4>
      <p style="margin-top:10px;">
        You want to delete this featured this week ?
      </p>
    `,
      // message: 'Are you sure you want to delete this image ?',
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Confirm',
    rejectLabel: 'Cancel',
      // ❌ Remove icons
    acceptIcon: '',
    rejectIcon: '' , 

      accept: () => {
        var updatedata = '{"disable":true}';
        // console.log(cmsmodule._id);
        this.featuredThisWeekService.updateFeaturedThisWeek(featuredThisWeekData._id, updatedata).pipe(takeUntil(this.destroy$)).subscribe(data => {
            this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'featured-this-week Deleted', life: 3000 });
            this.loadFeaturedThisWeekList(this.lastTableLazyLoadEvent);
          },
          err => {
            this.errorMessage = err.error.message;
          }
        );
      },
      reject: () => {
        this.loadFeaturedThisWeekList(this.lastTableLazyLoadEvent);
      }
    });
  }

  onEditFeaturedThisWeek(featuredThisWeekData) {
    this.router.navigate(['/manage/featured-this-week/edit/' + featuredThisWeekData._id]);
  }

  addColumns() {
    this.hide = false;
  }

  removeColumns() {
    this.hide = true;
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
